export default "__VITE_ASSET__Cmc8MgjX__"